const getAccountInformation = () => {
    return ApiClient.get('/account');
};

const updateAccountInformation = (data, fieldsToValidate) => {
    const params = fieldsToValidate ? { field: fieldsToValidate } : {};
    return ApiClient.put('/account', params, data);
};

const lockAccountInformation = () => {
    return ApiClient.post('/account/lock', {}, {});
};

export { getAccountInformation, updateAccountInformation, lockAccountInformation };
